import React from "react";
import {Tooltip} from "antd";
import {FileSearchOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TableContainer, ActionButtons} from "./ResponsiveDataTable.styles";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";

const TABLE_PREFIX = "poolTable";
const ResponsiveDataTable = ({data, loading, currentPage, setCurrentPage, dataCount}) => {
    const {t} = useTranslation(["pools"]);

    const onClickDetailButton = url => {
        window.open(`${url}`, "_blank");
    };
    const renderActionButtons = ({payment, id}) => {
        const permisions = {
            show: true
        };
        return (
            <ActionButtons>
                {permisions.show && Boolean(payment?.dekontUrl) && (
                    <Tooltip title={"Dekont Görüntüle"}>
                        <CustomButton
                            data-testid="detailButton"
                            onClick={() => onClickDetailButton(payment?.dekontUrl)}
                            icon={<FileSearchOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
            </ActionButtons>
        );
    };

    const resolveStatus = status => {
        switch (status) {
            case 1:
                return "Beklemede";
            case 2:
                return "Ödeme Alındı";
            case 3:
                return "Ödeme Alınamadı";
            default:
                return "-";
        }
    };

    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                pagination={{
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                }}
                rowKey="_id"
                rowClassName="hello"
                dataSource={data}
                data-testid="poolDataTable"
                loading={loading}
            >
                <TableContainer.Column
                    title={t("actions.action", {ns: "common"})}
                    dataIndex="_id"
                    render={(id, payment) => {
                        return (
                            <span
                                data-testid="actionButtons"
                                data-label={t("actions.action", {ns: "common"})}
                            >
                                {renderActionButtons({payment, id})}
                            </span>
                        );
                    }}
                />
                <TableContainer.Column
                    dataIndex="refNo"
                    title={"Ref No"}
                    ellipsis={{showTitle: false}}
                    render={refNo => (
                        <span data-testid="refNo" data-label={`Ref No:`}>
                            <Tooltip placement="topLeft" title={refNo}>
                                {refNo}
                            </Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="status"
                    title={t("fields.status", {ns: "common"})}
                    render={status => (
                        <span
                            data-testid="status"
                            data-label={`${t("fields.status", {ns: "common"})}:`}
                        >
                            {resolveStatus(status)}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="subCompanyName"
                    title={t("fields.subcompany", {ns: "common"})}
                    render={subCompanyName => (
                        <span
                            data-testid="subCompanyName"
                            data-label={`${t("fields.subcompany", {ns: "common"})}:`}
                        >
                            {subCompanyName || "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="amount"
                    title={"Tutar"}
                    render={amount => (
                        <span data-testid="amount" data-label={`Tutar:`}>
                            {amount || "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="vatAmount"
                    title={"KDV Tutarı"}
                    render={vatAmount => (
                        <span data-testid="vatAmount" data-label={`KDV Tutar:`}>
                            {vatAmount || "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="amountWithVat"
                    title={"KDV Dahil Tutar"}
                    render={(_, row) => (
                        <span data-testid="amountWithVat" data-label={`KDV Dahil Tutar:`}>
                            {row?.amount + row?.vatAmount || "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="message"
                    title={"Mesaj"}
                    ellipsis={{showTitle: false}}
                    render={message => (
                        <span data-testid="message" data-label={`Mesaj:`}>
                            <Tooltip placement="topLeft" title={message}>
                                {message || "-"}
                            </Tooltip>
                        </span>
                    )}
                />
            </TableContainer>
        </>
    );
};

export default ResponsiveDataTable;
